import {COLORS, SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const FilterFlyoutLoading: React.FC = () => {
  return (
    <Wrapper data-testid="filterFlyoutLoadingView">
      <ViewSection>
        <SkeletonBlock $width="30%" />
        <ViewSectionElements>
          <SkeletonBlock $width="60%" $height="38px" />
          <SkeletonBlock $width="38%" $height="38px" />
        </ViewSectionElements>
      </ViewSection>

      <ViewSection>
        <SkeletonBlock $width="30%" />
        <SkeletonBlock $height="38px" />
      </ViewSection>

      <ViewSection>
        <SkeletonBlock $width="20%" />
        <SkeletonBlock $width="40%" />
        <SkeletonBlock $height="38px" />
        <SkeletonBlock $height="1px" />
        <SkeletonBlock />
      </ViewSection>

      <ViewSection>
        <SkeletonBlock $width="20%" />
        <SkeletonBlock $height="38px" />
      </ViewSection>

      <ViewSection>
        <SkeletonBlock $width="20%" />
        <SkeletonBlock $height="50px" />
      </ViewSection>

      <ViewSection>
        <SkeletonBlock $width="20%" />
        <SkeletonBlock $height="50px" />
      </ViewSection>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const ViewSection = styled.section`
  padding: 1.5rem 1rem 1.9rem;
  background-color: ${COLORS.White};
  min-height: 8.13rem;
  box-sizing: border-box;
`;

const ViewSectionElements = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
